import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const Title = styled.h1`
  ${Text('xlarge1', 'alternate')};
  margin-bottom: ${spacing(1)};
  color: ${(props) => props.theme.colors.palette.accent.base};
  width: 100%;
  text-align: center;
`

export const StoreDetailsHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing(3)} 0;
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin: ${spacing(6)} 0;
  }
`
